'use strict';

var PricingSummaryPanelConfig = function PricingSummaryPanelConfig($stateProvider) {
  $stateProvider.state('app.pricing-summary', {
    url: '/workflow/pricing-summary',
    ifFeatureEnabled: ['DYNAMIC_AVAILABILITY'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/pricing-summary-panel.html'),
        controller: 'PricingSummaryPanelController'
      },
      'mainToolbar': {
        template: require('../templates/pricing-summary-toolbar.html'),
        controller: 'PricingSummaryPanelToolbarController'
      }
    }
  });
};
module.exports = PricingSummaryPanelConfig;
PricingSummaryPanelConfig.$inject = ['$stateProvider'];